import { Download, FileText } from 'lucide-react';
import { config } from '@/lib/env';
import { safeHttpUrl } from '@/utils/format';

const UNAVAILABLE_MESSAGE =
  'The Provider Update Form is not available right now. Please try again later, or call Provider Claim Information at 866-458-7499.';

/**
 * Forms (US-017). The portal links to the Provider Update Form and does nothing else with it: no
 * fillable fields, no validation, no submission endpoint, and no form data on an INSPYR system (BR-05).
 */
export function FormsPage(): React.JSX.Element {
  const href = safeHttpUrl(config.providerUpdateFormUrl);

  return (
    <section aria-labelledby="forms-heading" className="flex flex-col gap-5">
      <header>
        <h1 id="forms-heading" className="text-brand-600 text-xl font-bold">
          Forms
        </h1>
        <p className="text-muted mt-1 text-sm">
          Download the form, complete it offline, and submit it through the Bankers Fidelity intake
          channel printed on it.
        </p>
      </header>

      <section
        aria-label="Provider Update Form"
        className="border-line rounded-xl border bg-surface p-6 shadow-sm"
      >
        <div className="flex items-start gap-4">
          <FileText aria-hidden="true" className="text-brand-500 mt-0.5 h-6 w-6 flex-none" />
          <div className="min-w-0">
            <h2 className="text-ink text-base font-bold">Provider Update Form</h2>
            <p className="text-muted mt-1 text-sm">
              Use this form to report a change to your practice details.
            </p>

            {href === null ? (
              <p role="status" className="text-muted mt-4 text-sm">
                {UNAVAILABLE_MESSAGE}
              </p>
            ) : (
              <a
                href={href}
                target="_blank"
                rel="noreferrer"
                className="bg-brand-surface hover:bg-brand-surface-hover mt-4 inline-flex items-center gap-2 rounded-md px-4 py-2 text-sm font-medium text-on-brand"
              >
                <Download aria-hidden="true" className="h-4 w-4" />
                Download PDF
                <span className="sr-only">(opens in a new tab)</span>
              </a>
            )}
          </div>
        </div>
      </section>
    </section>
  );
}
